/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedProductCarousel_collectionsModules = {
    readonly title: string | null;
    readonly itemsConnection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"SharedProductCarouselItem_edge">;
        } | null> | null;
    } | null;
    readonly " $refType": "SharedProductCarousel_collectionsModules";
};
export type SharedProductCarousel_collectionsModules$data = SharedProductCarousel_collectionsModules;
export type SharedProductCarousel_collectionsModules$key = {
    readonly " $data"?: SharedProductCarousel_collectionsModules$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedProductCarousel_collectionsModules">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedProductCarousel_collectionsModules",
  "type": "CollectionsModulesPhotoCarousel",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemsConnection",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsItemsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CmsItemsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "SharedProductCarouselItem_edge",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '4a59ad7d29962b083d73ec73633970b1';
export default node;
